<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-header text-center">
        <h4>REPORTE DE GASTOS</h4>

        <form
          action=""
          [formGroup]="buscarForm"
          (ngSubmit)="buscarExistencia()"
          class="form-horizontal form-material noprint"
          id="categoryform"
          novalidate
        >
          <button onclick="window.print();return false;">
            <i class="fa fa-print"></i>
          </button>

          <div class="form-row">
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['inicio']"
                [controlName]="'Fecha Inicio'"
              >
                <label for="inicio">Fecha Inicio</label>
                <input
                  class="form-control"
                  type="date"
                  id="inicio"
                  formControlName="inicio"
                />
              </app-form-error-wrapper>
            </div>
            <div class="col">
              <app-form-error-wrapper
                [control]="buscarForm.controls['fin']"
                [controlName]="'Fecha final'"
              >
                <label for="fin">Fecha fin</label>
                <input
                  class="form-control"
                  type="date"
                  id="fin"
                  formControlName="fin"
                />
              </app-form-error-wrapper>
              <!--              <input type="date" class="form-control" [ngModel]="final">-->
            </div>

            <div class="col-xs-12 col-md-2 mt-4">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="buscarForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Buscar'"
                ></app-button-loader>
              </button>
            </div>
            <!--              <button type="submit" class="btn btn-primary" (click)="ListarExistencia()">Buscar</button>-->
          </div>
        </form>
      </div>
      <div class="card-body">
        <table class="table table-bordered table-hover table-responsive-md">
          <thead>
            <tr>
              <th>#</th>
              <th>Descripcion</th>
              <th>Fecha</th>
              <th>Monto</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of existencia; let i = index">
            <tr>
              <th scope="row">{{ i + 1 }}</th>
              <td>{{ data.descripcion }}</td>
              <td>{{ data.fecha }}</td>
              <td>{{ data.monto }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2"></td>
              <td colspan="1">SUBTOTAL</td>
              <td class="text-left">
                {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
